import { ManageAssortmentCategories } from '@features/TimberBuyer/SalesAgreements/PricePeriods/AssortmentCategories/ManageAssortmentCategories'
import { createFileRoute } from '@tanstack/react-router'
import { t } from '@utils/i18n-to-migrate'

const ManageAssortmentCategoriesRoute: React.FC = () => {
  const { timberBuyerId, salesAgreementId, pricePeriodId } = Route.useParams()

  return (
    <ManageAssortmentCategories
      timberBuyerId={timberBuyerId}
      salesAgreementId={salesAgreementId}
      pricePeriodId={pricePeriodId}
    />
  )
}

export const Route = createFileRoute(
  '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/$pricePeriodId/assortment-categories/',
)({
  component: ManageAssortmentCategoriesRoute,
  staticData: {
    breadcrumb: t('timberbuyer-salesagreements-priceperiods.assortmentCategories.breadcrumb'),
  },
})
